module.exports = __webpack_public_path__ + "static/scale-model-of-city-park-in-corona-california-bb60e3f7c6ed1b06b2a99a0d667612b6.png";